import React, { createContext, useContext, useEffect, useState } from 'react';

import {
  getRuntimeTenantService,
  TenantThemeFile,
} from '~/utils/tenantConnection';
import { storage } from '~/utils/storage';

type TenantExtras = TenantThemeFile['theme']['extras'];

interface ITenantContext {
  extras?: TenantExtras;
  isLoading: boolean;
}

const TenantContext = createContext<ITenantContext>({
  isLoading: true,
});

const THEME_CACHE_KEY = '@Queima::tenant_theme';

export const useTenantContext = () => useContext(TenantContext);

export const TenantProvider: React.FC = ({ children }) => {
  const [extras, setExtras] = useState<TenantExtras>();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchTenantTheme();
  }, []);

  async function fetchTenantTheme() {
    try {
      const cached = await storage.getItem(THEME_CACHE_KEY);
      if (cached) {
        const parsed: TenantThemeFile = JSON.parse(cached);
        setExtras(parsed.theme.extras);
      }

      const service = await getRuntimeTenantService();
      const theme = await service.getTenantResourceService().getTheme();

      await storage.setItem(THEME_CACHE_KEY, JSON.stringify(theme));
      setExtras(theme?.theme.extras);
    } catch {
      // keep cached data if available
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <TenantContext.Provider value={{ extras, isLoading }}>
      {children}
    </TenantContext.Provider>
  );
};
